import { gql } from '@apollo/client'
import { CHATBOT_CONVERSATION_FIELDS } from './chatbot_conversation'

export const HEALTH_DATA_REPORT_FIELDS = gql`
  ${CHATBOT_CONVERSATION_FIELDS}
  fragment HealthDataReportFields on HealthDataReport {
    id
    startDate
    endDate
    kind
    focusAreas
    reportData
    createdAt
    readAt
    lastState {
      id
      kind
      createdAt
    }
    conversation {
      ...ChatbotConversationFields
    }
  }
`
